import { render } from "./Modal.vue?vue&type=template&id=2aa5e11a"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=2aa5e11a&lang=css"
script.render = render

export default script